/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-12 21:47:46
 */
export default {
  lang: "英语",
  landing: {
    name1: "Mở Carlcare",
    name2: "Đặt chỗ",
    name3: "Với Carlcare, bạn có thể kiểm tra đơn hàng của mình bất cứ lúc nào.",
    name4: "",
    name5: "Trượt sang phải",
    name6: "Xác minh hoàn tất",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for Infinix/Tecno/itel designated models.",
    name11: "Starting from ₱500, you can get your battery replaced with no labor fee.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Flat Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    // name16: "Lower and Transparent Pricing",
    // name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy a 3-month warranty for your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. If you join the flat price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare hotline at 02-8705-4200.",
    name31: "Carlcare Statements:",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
  },
  order: {
    name1: "Chọn chế độ thiết bị",
    name2: "Mô tả lỗi:",
    name3: "Bấm để chọn cửa hàng bảo dưỡng",
    name4: "Cửa hàng Bảo dưỡng:",
    name5: "Thời gian Đặt chỗ:",
    name6: "Vui lòng mô tả chi tiết về vấn đề thiết bị của bạn!",
    name7: "Bấm để chọn thời gian đến",
    name8: "Vui lòng nhập chi tiết liên lạc chính xác của bạn để chúng tôi có thể liên hệ với bạn",
    name9: "Thời gian đặt chỗ khả dụng như sau",
    name10: "Xin vui lòng nhập số điện thoại của bạn",
    name11: "Giá",
    name12: "Thông tin cá nhân:",
    name13: "Xin vui lòng nhập tên của bạn",
    name14: "Gửi đi",
    name15: "Hủy",
    name16: "OK",
  },
  shops: {
    name1: "Dựa trên thương hiệu mà bạn chọn, các cửa hàng sau có thể phục vụ bạn!",
    name2: "Sắp được ra mắt tại nhiều cửa hàng bán lẻ hơn! Hãy cùng đón chờ với chúng tôi!",
  },
  price: {
    name1: "Thương hiệu",
    name2: "Kiểu máy",
    name3: "MỤC",
    name4: "Giá",
    name5: "Xin lưu ý:",
    name6: "Các mức giá này chỉ để tham khảo và giá thực tế sẽ tùy thuộc vào điều kiện thiết bị của bạn.",
    name7: "Nếu không có ký hiệu đặc biệt nào, đơn vị giá sẽ là đơn vị tiền tệ địa phương.",
    name8: "Rất tiếc! Không có thông tin nào về mức giá ở khu vực hiện tại.",
    name11:"Chi phí nhân công",
    name12:"Tổng giá",
    name13: "5. Nếu chi phí nhân công là \"/\", điều đó có nghĩa là chi phí nhân công cần được tư vấn với cửa hàng.",
    item_main_board: "Bảng mạch chủ",
    item_screen_frame: "Màn hình (Có viền)",
    item_screen_screen_frame: "Màn hình phụ (Có viền)",
    item_touch_screen: "Màn hình cảm ứng",
    item_camera: "Máy ảnh",
    item_fixed_focus_camera: "Máy ảnh lấy nét cố định",
    item_auto_focus_camera: "Máy ảnh lấy nét tự động",
    item_screen: "Màn hình",
    item_secondary_screen: "Màn hình phụ",
    item_fingerprint_module: "Mô-đun vân tay",
    item_speaker: "Loa",
    item_receiver: "Người nhận",
    item_small_board: "Bảng nhỏ",
    item_battery_cover: "Nắp pin",
    item_battery: "Pin",
    item_charger: "Bộ sạc",
    item_usb_cable: "Cáp USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Không có dữ liệu",
    name2: "Nhà cung cấp Dịch vụ Bảo dưỡng:",
    name3: "Nhãn hiệu dịch vụ:",
    name4: "Số điện thoại:",
    name5: "Số lượng Đơn hàng:",
    name6: "Đánh giá Dịch vụ",
    name7: "Môi trường Phục vụ:",
    name8: "Thái độ Phục vụ:",
    name9: "Hiệu quả Dịch vụ:",
    name10: "Chất lượng Dịch vụ:",
    name11: "Đánh giá của khách hàng",
    name12:"đến",
    name13:"Đã tắt",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Mở Carlcare",
    name1: "Vui lòng chụp ảnh màn hình thông tin đặt chỗ và lưu thành giấy biên nhận để truy cập dịch vụ ưu tiên.",
    name2: "Đã gửi thành công",
    name3: "1. Dọn dẹp dữ liệu",
    name4: "Vui lòng sao lưu các dữ liệu riêng tư quan trọng trên điện thoại của bạn trước",
    name5: "2. Tắt mật khẩu khi bật nguồn",
    name6: "Trước khi đến cửa hàng dịch vụ, vui lòng",
    name7: "Cửa hàng Bảo dưỡng",
    name8: "Thời gian Đặt chỗ",
    name9: "Mô tả lỗi",
    name10: "Model Thiết bị",
    name11: "Số đơn hàng",
    name12: "Thông tin Đặt hàng",
  },
  title: {
    
    name1: "Hỗ trợ các quốc gia sau:",
    name2: "Chọn Kiểu loại",
    name3: "Đặt trước",
    name4: "Chi tiết về Cửa hàng Bảo dưỡng",
    name5: "Lựa chọn Cửa hàng Bảo dưỡng",
  },
  error: {
    
    name1: "Không có dữ liệu nào. Vui lòng kiểm tra thông tin sửa chữa của bạn",
    name2: "Cần thêm hỗ trợ? Vui lòng liên hệ chúng tôi.",
    name3: "Rất tiếc, không có trung tâm Carlcare nào ở khu vực hiện tại.",
    name4: "Trước tiên hãy chọn một trung tâm dịch vụ",
    name5: "Bị lỗi",
    name6: "Trước tiên hãy chọn model thiết bị",
    name7: "Chi tiết",
    name8: "Vui lòng mô tả nhu cầu của bạn một cách chi tiết",
    name9: "",
  },
  add1:{
    "name0": "vi-rVN",
    "name1": "Đơn hàng của bạn đã được xác nhận. Chúng tôi mong đợi bạn sẽ đến.",
    "name2": "Chọn thành phố",
    "name3": "Vui lòng nhập số điện thoại có %1$s chữ số.",
    "name4": "Giờ trong tuần",
    "name5": "Thứ Hai",
    "name6": "Thứ 3",
    "name7": "Thứ 4",
    "name8": "Thứ 5",
    "name9": "Thứ 6",
    "name10": "Thứ bảy",
    "name11": "Chủ Nhật",
    "name12": "Nhập quốc gia và tìm kiếm"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "Khác",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Nhấn để chuyển hướng",
    name3:"Mở ứng dụng Carlcare để đánh giá đơn hàng",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Chọn Dịch vụ",
    name7:"Dọn dẹp miễn phí",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "Thông tin không đúng",
    "cancelReason1": "Không thể đến đúng giờ",
    "cancelReason2": "Đơn hàng trùng lặp/không phải đơn hàng của tôi",
    "cancelReason3": "Lỗi không tái diễn",
    "cancelReason4": "Chỉ để kiểm tra/truy vấn/sự kiện/…",
    "cancelReason5": "Giá cao",
    "cancelReason6": "Thiếu nguyên liệu",
    "cancelReason7": "Không có dịch vụ khác biệt",
    "cancelReason8": "Cửa hàng ở quá xa",
    "cancelReason9": "Cửa hàng đã đóng cửa",
    "cancelReason10": "Thái độ phục vụ kém",
    "cancelReason11": "Thay thế/sửa chữa cho nhãn hiệu khác",
    "cancelReason12": "Không thể tìm thấy cửa hàng",
    "cancelReason13": "Khác",
    "cancelOrder": "Hủy bỏ Đặt hàng",
    "reason_dialog_title": "Vui lòng cho chúng tôi biết lý do hủy bỏ",
    "Cancel": "Hủy bỏ",
    "OK": "OK",
    "name1": "Nhập mã xác nhận",
    "name2": "Mã xác nhận không hợp lệ",
    "repair_reservation_detail_canceled": "Đơn hàng này đã bị Hủy bỏ!",
    "purchase_cancel_dialog_content": "Bạn xác nhận hủy đơn hàng này?",
    "yes": "Đồng ý",
    "no": "Không"
}
};
